import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCartStore } from "../../store/cartStore";
import { ROUTES } from "../../constants/routes";

function AddToCartButton({ product, quantity = 1, className }) {
  const { t } = useTranslation();
  const addItem = useCartStore((state) => state.addItem);
  const [added, setAdded] = useState(false);

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    addItem(product, quantity);
    setAdded(true);
    window.setTimeout(() => setAdded(false), 2000);
  };

  const defaultClass =
    "caf-btn caf-btn--primary inline-flex min-h-[42px] items-center justify-center px-5 py-2 text-sm";

  return (
    <button
      type="button"
      className={className || defaultClass}
      onClick={handleClick}
      aria-label={t("Add to cart")}
    >
      {added ? t("Added to cart") : t("Add to cart")}
    </button>
  );
}

export default AddToCartButton;
